<div fxLayout="column" fxLayoutGap="3%">

    <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="2%">
        <aw-gravatar-picture [user]="this.loggedUser" [imageType]="'retro'"></aw-gravatar-picture>
    </div>

    <div class="welcome">
        <p>
            Welcome back, <strong> {{this.loggedUser.firstName}} </strong>
        </p>
    </div>

    <div fxLayout="row" fxLayoutAlign="center">
        <div class="role">
            {{this.loggedUser.role | fullCaps}}
        </div>
    </div>


    <mat-card appearance="outlined" *awIsInAnyRole="[roles.customer, roles.tester]" class="company-card" fxLayoutGap="3%">
        <mat-card-header>
            <mat-card-title>Company</mat-card-title>
        </mat-card-header>
        <mat-card-content fxLayout="row" fxLayoutGap="5%" fxLayout="80" fxLayoutAlign="center">
            <div fxLayout="column" fxLayoutAlign="center" class="w-80" fxLayoutGap="2%">
                <div class="company-grid">
                    <p class="grid-header">Company name</p>
                    <p class="contacts"> {{this.company?.companyName}} </p>
                    <p class="grid-header">Address</p>
                    <p class="contacts"> {{company?.companyAddress}} </p>
                    <p class="grid-header">Email</p>
                    <p class="contacts">{{company?.companyEmail}}</p>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" class="informations-card" fxLayoutGap="3%">
        <mat-card-header>
            <mat-card-title>Contact</mat-card-title>
        </mat-card-header>

        <mat-card-content fxLayout="row" fxLayoutGap="5%" fxLayout="80" fxLayoutAlign="center">

            <div fxLayout="column" fxLayoutAlign="center" class="w-80" fxLayoutGap="2%">
                <div class="informations-grid">
                    <p class="grid-header">Email</p>
                    <p class="contacts"> {{this.loggedUser.email}} </p>
                    <p class="grid-header">Phone</p>
                    <p class="contacts"> {{this.loggedUser.phone}} </p>
                </div>
            </div>

        </mat-card-content>
        <mat-divider></mat-divider>


        <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="5%">
            <button mat-button routerLink="/reserved/profile/edit">
                Edit your profile
            </button>
        </div>
    </mat-card>

    <mat-card appearance="outlined" class="informations-card" fxLayoutGap="3%">

        <mat-card-header>
            <mat-card-title>Notifications</mat-card-title>
        </mat-card-header>


        <mat-card-content fxLayout="row" fxLayoutGap="5%" fxLayout="80" fxLayoutAlign="center">

            <div fxLayout="column" fxLayoutAlign="center" class="w-80" fxLayoutGap="2%">
                <ng-container *ngFor="let item of notifications; index as i">
                    <div class="notifications-grid">
                        <p class="grid-header">{{ item.type }}</p>
                        <div>
                            <ng-container *ngFor="let option of item.channels; index as j">
                                <div fxLayout="row" fxLayoutGap="5%" fxLayoutAlign="left">
                                    <mat-slide-toggle
                                    class="toggleChange"
                                    (toggleChange)="updateNotificationsOption(i , j)"
                                    checked="{{ option.enabled }}"
                                    >
                                        <p class="contacts">{{ option.channel }}</p>
                                    </mat-slide-toggle>
        
                                </div>
                            
                            </ng-container>
                        </div>
                    </div>
                </ng-container>

            </div>
            
        </mat-card-content>

        <mat-divider></mat-divider>

        <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="5%">
            <button mat-button (click)="saveNotificationsSettings()">
                Save
            </button>
        </div>

    </mat-card>
</div>